import { render, staticRenderFns } from "./PreLoader.vue?vue&type=template&id=55a234cc&scoped=true&"
import script from "./PreLoader.vue?vue&type=script&lang=js&"
export * from "./PreLoader.vue?vue&type=script&lang=js&"
import style0 from "./PreLoader.vue?vue&type=style&index=0&id=55a234cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a234cc",
  null
  
)

export default component.exports